import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import { createResonanceProject } from '../../../redux/projects/projectsActions';
import validate from '../../../utils/validate';
import { createResonanceProjectYopValidation } from '../validation';
import ResonanceCreationForm from './ResonanceCreationForm';
import { LANGUAGES_SHORT, RESONANCE_STRUCTURE, RESONANCE_THEMES, RESONANCE_VISIONS } from '../../../constants';

const ResonanceCreation = () => {
  const dispatch = useDispatch();

  const createResonanceProjectInitialValues = {
    projectName: '',
    assignUser: '',
    dataStructure: RESONANCE_STRUCTURE.RESPONDENTS,
    lang: LANGUAGES_SHORT.ENGLISH,
    vision: RESONANCE_VISIONS.DEFAULT,
    resonanceTheme: RESONANCE_THEMES.FACTIVE,
    file: null,
    activeUsers: [],
  };

  const handleCreateProject = useCallback(
    (values) => {
      dispatch(createResonanceProject(values));
    },
    [dispatch],
  );

  return (
    <Form
      initialValues={createResonanceProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createResonanceProjectYopValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <ResonanceCreationForm handleSubmit={handleSubmit} />}
    />
  );
};

export default memo(ResonanceCreation);
